import { keepPreviousData } from "@tanstack/react-query";

import { $api, orderingParam } from "./client";
import type { components } from "./schema";
import type { Flavor } from "./sources";

export type SourceExecution = components["schemas"]["SourceExecution"];

/** Paginated, read-only. */
export const useSourceExecutions = ({
  producesItem,
  ordering,
  ...query
}: {
  search?: string;
  source?: number;
  producesItem?: number[];
  location?: number[];
  flavor?: Flavor[];
  completed?: boolean;
  /** Only open executions due before today. */
  overdue?: boolean;
  ordering?: string;
  limit?: number;
  offset?: number;
} = {}) =>
  $api.useQuery(
    "get",
    "/api/v1/source-executions/",
    {
      params: {
        query: {
          ...query,
          produces_item: producesItem,
          ordering: orderingParam(ordering),
        },
      },
    },
    { placeholderData: keepPreviousData },
  );
